import Head from 'next/head';
import { DefaultSeo } from 'next-seo';

export default function StructuredData() {
  return (
    <>
      <DefaultSeo
      // Define default SEO configuration here
      />
      <Head>
        <title>
          eighteen yards | sports digital marketing services
        </title>
        <meta
          name="description"
          content="Explore our comprehensive range of sports digital marketing services at eighteen yards. We specialise in digital strategy, performance marketing, training, and data analytics to elevate your brand's online presence."
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              "url": "https://eighteenyards.com/services/strategy",
              "name": "eighteen yards | sports digital marketing strategy",
              "description": "Unleash your digital potential with our Sports Digital Marketing Strategies. Tailored solutions to outperform your competition. Contact us today.",
              "mainEntity": {
                "@type": "Service",
                "serviceType": "Sports Digital Marketing Strategy",
                "provider": {
                  "@type": "Organization",
                  "name": "eighteen yards",
                  "url": "https://eighteenyards.com"
                },
                "description": "At eighteen yards, we are committed to empowering your approach towards digital and propelling you towards your goals. Our Strategy services will provide you with a competitive edge across your digital channels.",
                "hasOfferCatalog": {
                  "@type": "OfferCatalog",
                  "name": "Sports Digital Marketing Strategy",
                  "itemListElement": [
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Digital Strategy",
                        "description": "We craft customised digital strategies tailored to your unique needs and objectives. Our approach is to combine industry expertise, data-driven insights, and innovative technology to deliver solutions that align precisely with your business needs."
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Performance Marketing Strategy",
                        "description": "Our Performance Marketing Strategies are all about maximising your return on investment. We don't just focus on driving traffic, but on converting that traffic into tangible results, whether it's sales, sign-ups, or any other action aligned with your goals."
                      }
                    }
                  ]
                }
              }
            }
            ),
          }}
        />
      </Head>
    </>
  )
}
